/*
 * @Author: your name
 * @Date: 2021-07-12 14:09:03
 * @LastEditTime: 2023-09-08 15:46:07
 * @LastEditors: 窦云飞 df1987131@yeah.net
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /cmdc-web-v/Users/douyunfei/Documents/epec-mall/api/enquiry.js
 */
import $axios from '@/modules//projectA//serviceOther/index';
import request from '../request';
import { url } from '../urlConfig';

const server = {
  // PC-商品搜索 批量选择询价商品信息 // 采购计划 需求计划的选择商品
  queryProductPage(params) {
    return request.post('/product/mall/queryProductPage', params);
  },
  /* // 商品类目
  selectCategoryByParentId: function (params) {
    return request.post("/product/category/selectCategoryByParentId", params);
  }, */
  // 商品类目 新
  transferCategoryTree(params) {
    return request.fetch('/product/category/usefulCategoryTree', params);
  },
  // 采购商--查询询价单列表
  queryEnquiryList(params) {
    return request.post('/transaction-center/Enquiry/queryEnquiryList', params);
  },
  // 导入商品列表
  enquiryProductExcelUpload(params) {
    return request.post('/transaction-center/Enquiry/enquiryProductExcelUpload', params);
  },
  // （PC）发起询价--发布询价
  addEnquiry(params) {
    return request.post('/transaction-center/Enquiry/addEnquiry', params);
  },
  // 查询询价单详情列表
  queryEnquiryDetailByEnquiryId(params) {
    return request.post('/transaction-center/Enquiry/queryEnquiryDetailByEnquiryId', params, { preventRepeat: false });
  },

  // 查询询价单详情
  queryEnquiryDetailForPublic(params) {
    return request.post('/transaction-center/Enquiry/queryEnquiryDetailForPublic', params);
  },

  // 询价查询公司及法人信用认证信息
  queryCompanyCreditGradePage(params) {
    return request.post('/data-center/companyGrade/queryCompanyCreditGradePage', params);
  },
  // 询价查询公司产品质量评价信息
  queryCompanyProductGradePage(params) {
    return request.post('/user-center/companyGrade/queryCompanyProductGradePage', params);
  },

  //  附件上传
  enquiryFileUpload(params) {
    return request.post('/transaction-center/Enquiry/fileUpload', params);
  },
  // 日志查询 就是审核记录
  queryEnquiryLogByPage(params) {
    return request.post('/purchase/businessAuditLog/page', params);
  },

  // 日志查询 就是审核记录
  querySupplierOfferList(params) {
    return request.post('/transaction-center/Enquiry/querySupplierOfferList', params);
  },

  // 日志查询 就是审核记录
  queryOfferListByPage(params) {
    return request.post('/transaction-center/Enquiry/queryOfferListByPage', params);
  },
  // 查询报价供应商
  queryWaitSelectionOfferListByPage(params) {
    return request.post('/transaction-center/enquiryPurchase/queryWaitSelectionOfferListByPage', params);
  },
  // 日志查询 就是审核记录
  cancelEnquiry(params) {
    return request.post('/transaction-center/Enquiry/cancelEnquiry', params);
  },
  // // 查询报价单详情-选商定价列表详情
  // querySupplierOfferDetailPage(params) {
  //   return request.post(
  //     '/transaction-center/Enquiry/querySupplierOfferDetailPage',
  //     params
  //   );
  // },
  // 选商
  modifyOfferStatus(params) {
    return request.post('/transaction-center/Enquiry/modifyOfferStatus', params);
  },
  // 采购商---删除草稿询价单
  removeEnquiry(params) {
    return request.post('/transaction-center/Enquiry/removeEnquiry', params);
  },
  // 供应商历史报价
  queryHistoryListPage(params) {
    return request.post('/transaction-center/Enquiry/queryHistoryListPage', params);
  },
  // 供应商历史报价
  restartEnquiry(params) {
    return request.post('/transaction-center/Enquiry/restartEnquiry', params);
  },
  // 一体化询价
  querySelectedPurchaseRequest(params) {
    return request.post('/transaction-center/purchaseRequest/querySelectedPurchaseRequest', params);
  },
  // 撤回
  callbackEnquiry(params) {
    return request.post('/transaction-center/Enquiry/callbackEnquiry', params);
  },
  // 回退
  returnEnquiry(params) {
    return request.post('/transaction-center/Enquiry/returnEnquiry', params);
  },
  // 延时
  changeSupplierOfferDelay(params) {
    return request.post('/transaction-center/Enquiry/changeEnquiryDelay', params);
  },
  // 选商定价开关
  queryOrderAskPrice(params) {
    return request.post('/user-center/companyConfig/queryOrderAskPrice', params);
  },
  // 选商定价 按钮
  updateViewOfferCount(params) {
    return request.post('/transaction-center/Enquiry/updateViewOfferCount', params);
  },
  // 发起磋商
  addSupplierOfferConsult(params) {
    return request.post('/transaction-center/Enquiry/addSupplierOfferConsult', params);
  },
  // 磋商报价记录--采购商
  offerConsultPurchaseRecord(params) {
    return request.post('/transaction-center/Enquiry/offerConsultPurchaseRecord', params);
  },
  // 磋商报价记录明细
  offerConsultRecordDetail(params) {
    return request.post('/transaction-center/Enquiry/offerConsultRecordDetail', params);
  },
  // // 查询询价单详情列表
  // queryEnquiryDetailByEnquiryId(params) {
  //   return request.post(
  //     '/transaction-center/Enquiry/queryEnquiryDetailByEnquiryId',
  //     params
  //   );
  // },
  // // 1:订单 2:预算 3:采购需求 4:采购计划 5:询比价 6:招投标 的审批流
  // queryAuditBusinessFlowLogList(params) {
  //   return request.post(
  //     '/purchase/businessAudit/queryAuditBusinessFlowLogList',
  //     params
  //   );
  // },
  hasAuthCode: (params) => {
    return request.post(`/ubm/member/hasAuthCode`, params);
  },
  approveList: (params) => {
    return request.post(`/purchase/audit/list`, params);
  },
  approveDetail: (params) => {
    return request.post(`/purchase/audit/detail`, params);
  },
  // 判断审批流开关
  queryOderConfig: (params) => {
    return request.post(`/user-center/companyConfig/queryOrderConfig`, params);
  },
  queryUserAddress: (params) => {
    return request.post(`/user-center/address/queryUserAddress`, params);
  },
  enquiryFileUrl() {
    return `${url.base}/transaction-center/Enquiry/fileUpload`;
  },

  // 地址删除
  deleteOrderAddress: (params) => {
    const newUrl = `${url.oldService}/memberportal/zh/api/addressInfo/deleteOrderAddress.do`;
    return $axios.post(newUrl, params);
  },
  OrderAddInfoHandle: (params) => {
    return $axios.post(`${url.oldService}/memberportal/zh/api/addressInfo/OrderAddInfoHandle.do`, params);
  },
  // 公司注册地：获取省接口
  getAreaByCountryCode: (params) => {
    const newUrl = `${url.oldService}/memberportal/zh/common/interface/getAreaByCountryCode.do`;
    return $axios.post(newUrl, params);
  },
  // 公司注册地：获取市接口
  getCityByAreaId: (params) => {
    return $axios.post(`${url.oldService}/memberportal/zh/common/interface/getCityByAreaId.do`, params);
  },
  // 公司注册地：获取区接口
  getDistrictByCityId: (params) => {
    return $axios.post(`${url.oldService}/memberportal/zh/common/interface/getDistrictByCityId.do`, params);
  },
  // 查询报价单详情-选商定价列表详情
  querySupplierOfferDetailPage: (params) => {
    return request.post(`/transaction-center/Enquiry/querySupplierOfferDetailPage`, params);
  },
  // 采购商---导出报价明细的比价表
  exportSupplierOffer: (params) => {
    return request.post(`/transaction-center/Enquiry/exportSupplierOffer`, params, {
      responseType: 'blob',
    });
  },

  // 询比价权限配置查询
  getInquirySheetConfig: (params) => {
    return request.fetch(`/user-center/companyConfig/getInquirySheetConfig`, params);
  },

  // 询比价权限配置配置
  addInquirySheetConfig: (params) => {
    return request.post(`/user-center/companyConfig/addInquirySheetConfig`, params);
  },

  // 询比价权限配置查询
  getInquirySheetConfigAndIsBuyerAdmin: (params) => {
    return request.fetch(`/user-center/companyConfig/getInquirySheetConfigAndIsBuyerAdmin`, params);
  },
  // 延时记录
  queryEnquiryOfferChangeList: (params) => {
    return request.post(`/transaction-center/enquiryOfferChange/queryEnquiryOfferChangeList`, params);
  },
  // 询比价采购方案部分数据
  purchasePlan: (params) => {
    return request.post(`/transaction-center/Enquiry/purchasePlan`, params);
  },
  //
  supplierCompare: (params) => {
    return request.post(`/transaction-center/Enquiry/supplierCompare`, params);
  },
  queryAuditBusinessFlowLogList: (params) => {
    return request.post(`/purchase/businessAudit/queryAuditBusinessFlowLogList`, params);
  },
  querySupplierCollectionPageInfo(params) {
    return request.post(`/transaction-center/supplierCollection/querySupplierCollectionPageInfo`, params);
  },
  // 删除报价单（作废状态）供应商
  removeOffer(params) {
    return request.post(`/transaction-center/enquirySupplier/removeOffer`, params);
  },
  // 删除询价单（作废状态） 采购商
  removeEnquiryPur(params) {
    return request.post(`/transaction-center/enquiryPurchase/removeEnquiry`, params);
  },
  // 校验询比价权限,
  checkEnquiryPower(params) {
    return request.post(`/transaction-center/Enquiry/checkEnquiryPower`, params);
  },
  // 公开/定向列表
  queryEnquiryPage(params) {
    return request.post(`/transaction-center/enquirySupplier/queryEnquiryPage`, params);
  },

  // 啥也不传
  // 询比价报价供应商配置查询
  queryPriceSupplierConfig(params) {
    return request.post(`/user-center/companyConfig/queryPriceSupplierConfig`, params);
  },
  // 保存的时候，{"data": 132}  -- 131支持查看报价供应商，132不支持查看报价供应商
  // 询比价报价供应商配置保存
  savePriceSupplierConfig(params) {
    return request.post(`/user-center/companyConfig/savePriceSupplierConfig`, params);
  },
  // 中选通知待确认的接口
  selectedWaitConfirm(params) {
    return request.post(`/transaction-center/enquirySupplier/selectedWaitConfirm`, params);
  },

  // 供应商填写报价 请求接口
  queryEnquiryDetailAndConsultByEnquiryId(params) {
    return request.post(`/transaction-center/Enquiry/queryEnquiryDetailAndConsultByEnquiryId`, params);
  },
  // 询价结果
  enquiryResultListByEnquiryId(params) {
    return request.fetch(`/transaction-center/Enquiry/enquiryResultListByEnquiryId`, params);
  },
  // 拒绝确认
  consultationWaitConfirm(params) {
    return request.post(`/transaction-center/enquirySupplier/consultationWaitConfirm`, params);
  },

  //
  queryCategoryByProductName(params) {
    return request.post(`/data-center/match/queryCategoryByProductName`, params);
  },

  addCategoryKeyword(params) {
    return request.post(`/data-center/match/addCategoryKeyword`, params);
  },
  // 报价报表查询
  queryEnquiryListReport(params) {
    return request.post(`/transaction-center/EnquiryEnterpriseStatistics/queryEnquiryList`, params);
  },
  // 查询报价单列表---供应商
  queryOfferListForAdminByPage(params) {
    return request.post('/transaction-center/Enquiry/queryOfferListForAdminByPage', params);
  },
  // 查询询价商品详情--分页
  queryEnquiryDetailByPage(params) {
    return request.post('/transaction-center/Enquiry/queryEnquiryDetailByPage', params);
  },
  /* 
    应急接口 
  */
  // 是否是应急供应商
  checkWhetherEnquirySupplier(params) {
    return request.fetch('/transaction-center/enquirySupplier/checkWhetherEnquirySupplier', params);
  },
  queryEmergencyEnquiryPage(params) {
    return request.post('/transaction-center/enquirySupplier/queryEmergencyEnquiryPage', params);
  },
  //  应急发布导入的接口
  enquiryProductExcelUploadYJ(params) {
    return request.post('/transaction-center/enquiryPurchase/enquiryProductExcelUpload', params);
  },
};

export default server;
